import { walkUpdateNodeTextContent, parseStringToDom } from "@/lib/domHelper";
import cartesian from "@/lib/cartesian";
import { isNullOrWhitespace } from "@/lib/whitespaceMethods";

// TODO delete all of these?
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function resolveCalculationPromiseBool(jsScript: string, contextNode: any) {
    throw new Error();
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function resolveCalculationPromise(jsScript: any, contextNode: any) {
    throw new Error();
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function resolveCalculation(jsScript: any, contextNode: any) {
    throw new Error();
}
export default resolveCalculation;

export function DfParseFloat(value: string | null | undefined | number) {
    // Remove spaces, dollar sign, commas, etc before parsing
    value = value == null ? null : value.toString().replace(/[^+0-9.-]+/g, "");
    return parseFloat(value!);
}
export function DfParseFloatWithoutNan(value: string | null | undefined | number) {
    const result = DfParseFloat(value);
    return isNaN(result) ? 0 : result;
}

export function parseBool(value: string | null | undefined | number) {
    if (value == null) {
        return null;
    }
    if (typeof value == "number") {
        return value != 0;
    }
    const valueStr = value.toString().toLowerCase();
    return valueStr == "1" || valueStr == "true" ? 1 : valueStr == "0" || valueStr == "false" ? 0 : null;
}

//export function DfGetTableRows(fetchXsrfFunc, urlFetcher, tableName, testMode, skip, top, sort) {
//    return DfGetAreaTableRows(fetchXsrfFunc, urlFetcher, null, tableName, testMode, skip, top, sort);
//}
//export function DfGetAllTableRows(fetchXsrfFunc, urlFetcher, tableName, testMode) {
//    return DfGetAllAreaTableRows(fetchXsrfFunc, urlFetcher, null, tableName, testMode);
//}
//export function DfGetAllTableValues(fetchXsrfFunc, urlFetcher, tableName, testMode, resultKey) {
//    return DfGetAllAreaTableValues(fetchXsrfFunc, urlFetcher, null, tableName, testMode, resultKey);
//}
//export function DfGetAllAreaTableRows(fetchXsrfFunc, urlFetcher, areaCode, tableName, testMode) {
//    return DfGetAreaTableRows(fetchXsrfFunc, urlFetcher, areaCode, tableName, testMode, null, null);
//}
//const tableCaches = {};
//export function DfGetAreaTableRows(fetchXsrfFunc, urlFetcher, areaCode, tableName, testMode, skip, top, sort) {
//    const tableCache = _DFResolveGetTableCache(areaCode, tableName, testMode, skip, top, sort);
//    //@ts-ignore
//    let allPromise = tableCache[null];
//    if (allPromise == null) {
//        //@ts-ignore
//        tableCache[null] = allPromise = (async () => {
//            const url = await urlFetcher("datasourceFetchData", { tenantCode: areaCode, tableKey: tableName, testMode: testMode, skip: skip, top: top, sort: JSON.stringify(sort) });
//            const tableResp = await fetch(url);
//            const tableDataCount = parseInt(tableResp.headers.get("x-df-datacount"));
//            const tableData = await tableResp.json();
//            return { data: tableData, dataCount: tableDataCount };
//        })();
//    }
//    return allPromise;
//}
//export function DfGetAllAreaTableValues(fetchXsrfFunc, urlFetcher, areaCode, tableName, testMode, resultKey) {
//    return _DFResolveTableLookup([DfGetAllAreaTableRows(fetchXsrfFunc, urlFetcher, areaCode, tableName, testMode)], resultKey);
//}
//
type HtmlContentCalculation = { id: string | undefined; text: string[] };
export function resolveHtmlContentCalculations(calculations: HtmlContentCalculation[], content: string | undefined) {
    const parsedDom = parseStringToDom(content);
    const processFunc = (element: HTMLElement) => {
        const calculation = !isNullOrWhitespace(element.id) ? calculations.find(calc => calc.id == element.id) : null;
        HtmlResolveCalculationElement(calculation, element);
    };
    HtmlProcessDeeperMatchedNodes(parsedDom.body, "conditional-block, calculation", processFunc);
    HtmlResolveIterableCalculations(parsedDom);
    return parsedDom.body.innerHTML;
}

//function _DFResolveGetTableCache(areaCode, tableName, testMode, skip, top, sort) {
//    let areaCache = tableCaches[areaCode];
//    if (areaCache == null) {
//        areaCache = tableCaches[areaCode] = {};
//    }
//    let tableCache = areaCache[tableName];
//    if (tableCache == null) {
//        tableCache = areaCache[tableName] = {};
//    }
//    let modeCache = tableCache[testMode];
//    if (modeCache == null) {
//        modeCache = tableCache[testMode] = {};
//    }
//    let skipCache = modeCache[skip];
//    if (skipCache == null) {
//        skipCache = modeCache[skip] = {};
//    }
//    let topCache = skipCache[top];
//    if (topCache == null) {
//        topCache = skipCache[top] = {};
//    }
//    const sortKey = JSON.stringify(sort);
//    let sortCache = topCache[sortKey];
//    if (sortCache == null) {
//        sortCache = topCache[sortKey] = {};
//    }
//    return sortCache;
//}

//function _DFResolveTableLookup(promiseLists, resultKey) {
//    return Promise.all(promiseLists).then(function (input) {
//        return [].concat.apply(
//            [],
//            input.map(i => i.data.map(v => v[resultKey])),
//        );
//    });
//}

function HtmlResolveCalculationElement(calculation: HtmlContentCalculation | null | undefined, element: HTMLElement) {
    const resolveFunc = {
        calculation: (calculation: HtmlContentCalculation | null | undefined, calculationElement: HTMLElement) => {
            const parent = calculationElement.parentElement!,
                notIterable = !calculation || !calculation.text.length,
                childWrapper = document.createElement("span");

            childWrapper.append(...calculationElement.children);
            walkUpdateNodeTextContent(childWrapper, calculation != null ? calculation.text[0] : "");
            parent.replaceChild(childWrapper, calculationElement);
            if (notIterable) {
                return;
            }
            childWrapper.dataset.isIterable = "true";
            const iterables = parent.dataset.iterables != null ? (JSON.parse(parent.dataset.iterables) as string[][]) : [];
            iterables.unshift(calculation.text);
            parent.dataset.iterables = JSON.stringify(iterables);
        },
        "conditional-block": (calculation: HtmlContentCalculation | null | undefined, conditionalElement: HTMLElement) => {
            if (calculation == null || parseBool(calculation.text[0]) === 1) {
                conditionalElement.replaceWith(...(conditionalElement.querySelector("div")!.children || []));
            } else {
                conditionalElement.outerHTML = "";
            }
        },
    };
    resolveFunc[element.nodeName.toLocaleLowerCase() as "calculation" | "conditional-block"](calculation, element);
}

function HtmlResolveIterableCalculations(parsedDom: Document) {
    const iterableElements = parsedDom.querySelectorAll("[data-iterables]");
    if (iterableElements.length != 0) {
        const processFunc = (iterableElement: HTMLElement) => {
            const iterables = JSON.parse(iterableElement.dataset.iterables!) as string[][];
            delete iterableElement.dataset.iterables;
            if (!(iterables.length == 1 && iterables[0].length == 1)) {
                const cartesianSets = cartesian(...iterables);
                const childWrapper = document.createElement("span");
                cartesianSets.forEach(set => {
                    const clonedElement = iterableElement.cloneNode(true) as HTMLElement;
                    const isIterables = clonedElement.querySelectorAll(`:scope > [data-is-iterable="true"]`);
                    for (let i = isIterables.length - 1; i >= 0; i--) {
                        walkUpdateNodeTextContent(isIterables[i], Array.isArray(set) ? set[i] : set);
                    }
                    childWrapper.append(clonedElement);
                });
                iterableElement.replaceWith(...childWrapper.children);
            }
        };
        HtmlProcessDeeperMatchedNodes(parsedDom.body, "[data-iterables]", processFunc);
    }
    parsedDom.querySelectorAll(`[data-is-iterable]`).forEach(elem => delete (elem as HTMLElement).dataset.isIterable);
}

function HtmlProcessDeeperMatchedNodes(node: HTMLElement, selector: string, func: (i: HTMLElement) => void) {
    const children = node.querySelectorAll(selector);
    for (let i = children.length - 1; i >= 0; i--) {
        HtmlProcessDeeperMatchedNodes(children[i] as HTMLElement, selector, func);
    }
    if (node.matches(selector)) {
        func(node);
    }
}
